"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var Tooltip_1 = require("./Tooltip");
var fdAppId = '7692650820';
var link = document.createElement('a');
var mightHaveWhatsappSupport = (navigator.userAgent.match(/Android|iPhone/i) && !navigator.userAgent.match(/iPod|iPad/i));
var root = document.documentElement || document;
if (mightHaveWhatsappSupport) {
    jquery_1.default(document.documentElement).addClass("whatsapp");
}
var SocialSharing = (function (_super) {
    __extends(SocialSharing, _super);
    function SocialSharing(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.popup = null;
        _this.mightHaveWhatsappSupport = mightHaveWhatsappSupport;
        return _this;
    }
    SocialSharing.prototype.defaultConfig = function () {
        return {
            eventNS: 'social',
            hashTag: "#FD",
            source: "FD.nl",
            siteUrl: 'https://fd.nl'
        };
    };
    SocialSharing.prototype.init = function () {
        jquery_1.default(root).on('click', '.share-social', jquery_1.default.proxy(this.toggleTooltip, this));
        jquery_1.default(root).on('click', '.share-facebook,.share-twitter,.share-linkedin,.share-whatsapp,.share-email', jquery_1.default.proxy(this.share, this));
        jquery_1.default(root).on('click', '.share-audio-embed', jquery_1.default.proxy(this.toggleEmbed, this));
    };
    SocialSharing.prototype.toggleTooltip = function (event) {
        var button = jquery_1.default(event.target).closest('.share-social')[0];
        Tooltip_1.Tooltip.getInstance().show(this.getContent(button), button, 'social-tooltip');
    };
    SocialSharing.prototype.toggleEmbed = function () {
        jquery_1.default("#embed-toggle").toggle();
    };
    SocialSharing.prototype.getContent = function (shareNode) {
        var title = shareNode.getAttribute('data-title') || '';
        var url = shareNode.getAttribute('data-url') || '';
        var intro = shareNode.getAttribute('data-intro') || '';
        var id = shareNode.getAttribute('data-id') || '';
        var embed = shareNode.getAttribute('data-audio-embed') || '';
        var content = ['<h1>Delen via</h1>'];
        content.push('<span class="share-twitter" data-media="twitter" data-url="', url, '" data-id="', id, '" data-title="', title, '" data-intro="', intro, '"><i class="ico ico-before ico-twitter"></i>Twitter</span>');
        content.push('<span class="share-linkedin" data-media="linkedin" data-url="', url, '" data-id="', id, '" data-title="', title, '" data-intro="', intro, '"><i class="ico ico-before ico-linkedin"></i>LinkedIn</span>');
        content.push('<span class="share-facebook" data-media="facebook" data-url="', url, '" data-id="', id, '" data-title="', title, '" data-intro="', intro, '"><i class="ico ico-before ico-facebook"></i>Facebook</span>');
        if (this.mightHaveWhatsappSupport) {
            content.push('<span class="share-whatsapp" data-media="whatsapp" data-url="', url, '" data-id="', id, '" data-title="', title, '" data-intro="', intro, '"><i class="ico ico-before ico-whatsapp"></i>Whatsapp</span>');
        }
        content.push('<span class="share-email" data-media="email" data-url="', url, '" data-id="', id, '" data-title="', title, '" data-intro="', intro, '"><i class="ico ico-before ico-envelope"></i>E-mail</span>');
        if (embed !== '') {
            content.push('<span class="share-audio-embed" data-media="embed" data-url="', embed, '" data-id="', id, '" data-title="', title, '" data-intro="', intro, '"><b>< /></b> Embed</span>');
            content.push('<textarea id="embed-toggle" style="display:none; color: black; margin-left: -5px; resize: none;" rows="8" ><iframe class="no-reload" style="margin-bottom:15px;width:100%;border:none;min-height:160px;" src="', embed, '"></iframe></textarea>');
        }
        return content.join('');
    };
    SocialSharing.prototype.getAbsoluteUrl = function (url) {
        link.href = url;
        return link.href;
    };
    SocialSharing.prototype.share = function (event) {
        var node = jquery_1.default(event.target).closest('[class*=share]');
        var url = this.getWindowUrl(node[0]);
        var media = node[0].getAttribute("data-media");
        SocialSharing.getBus().notify([this.config.eventNS, 'share'].join('.'), {
            socialNetwork: node.text(),
            articleID: node.attr('data-id')
        });
        if (media == "whatsapp" || media == "email") {
            document.location.href = url;
        }
        else {
            this.open(url);
        }
    };
    SocialSharing.prototype.getWindowUrl = function (shareNode) {
        var title = shareNode.getAttribute('data-title') || '';
        var url = this.getAbsoluteUrl(shareNode.getAttribute('data-url') || '');
        var intro = shareNode.getAttribute('data-intro') || '';
        var eTitle = encodeURIComponent(title);
        var eUrl = encodeURIComponent(url);
        var eIntro = encodeURIComponent(intro);
        var mode = shareNode.getAttribute('data-social-mode') || 'share';
        var media = shareNode.getAttribute('data-media');
        switch (media) {
            case "google":
                return 'https://m.google.com/app/plus/x/?v=compose&content=' + title + '%20' + this.config.source.toLowerCase();
            case "facebook":
                if (mode == 'message') {
                    return 'https://www.facebook.com/dialog/feed?redirect_uri=' + encodeURIComponent(this.config.siteUrl + '/#close_window') + '&display=popup&app_id=' + fdAppId + '&description=' + eIntro + '&link=' + eUrl;
                }
                return 'http://www.facebook.com/sharer.php?u=' + eUrl + '&t=' + eTitle + '&src=' + this.config.source.toLowerCase();
            case "twitter":
                if (mode == 'message') {
                    return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.createTwitterMessage(intro, url));
                }
                return 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.createTwitterMessage(title, url));
            case "linkedin":
                return 'http://www.linkedin.com/shareArticle?mini=true&url=' + eUrl + '&title=' + eTitle + '&summary=' + eIntro + '&source=' + this.config.source.toLowerCase();
            case "email":
                eTitle = encodeURIComponent('\'' + title + '\' | Artikel gedeeld via ' + this.config.source);
                eIntro = encodeURIComponent('Ik las dit artikel via ' + this.config.siteUrl + ' en wil het graag met u delen: \n' + url);
                return 'mailto:?subject=' + eTitle + '&body=' + eIntro;
            case "whatsapp":
                return 'whatsapp://send?text=' + encodeURIComponent('\'' + title + '\'\n' + url);
        }
    };
    SocialSharing.prototype.createTwitterMessage = function (title, url) {
        var message = ' ' + url + ' ' + this.config.hashTag;
        var charsLeft = 107;
        if (title.length >= charsLeft) {
            title = title.substring(0, charsLeft - 2);
            title = title + '..';
        }
        title = title + '.';
        message = title + message;
        return message;
    };
    SocialSharing.prototype.open = function (url) {
        if (this.popup && 'close' in this.popup) {
            this.popup.close();
        }
        this.popup = window.open(url, this.config.source.toLowerCase(), 'width=850,height=600,resizable=1,scrollbars=1');
        this.popup.moveTo((window.screen.width - 850) / 2, (window.screen.height - 600) / 2);
    };
    return SocialSharing;
}(Widget_1.Widget));
exports.SocialSharing = SocialSharing;
